import React from "react";
import clsx from "clsx";
import MaskIcon from "common_components/ui/mask_icon/mask_icon.ui";
import { ToggleIconButtonProps } from "interfaces/toggle_icon_button.interface";
import "./toggle_icon_button.ui.scss";

const ToggleIconButton = (props: ToggleIconButtonProps): React.ReactElement => {
  const { icon, label, isPressed, onToggle, disabled = false, className } = props;

  return (
    <button
      type="button"
      className={clsx("toggle_icon_button", className)}
      aria-label={label}
      aria-pressed={isPressed}
      title={label}
      disabled={disabled}
      onClick={onToggle}
    >
      <MaskIcon src={icon} size={18} />
    </button>
  );
};

export default ToggleIconButton;
